exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-inner{padding:0;max-width:600px;text-align:left}.tooltip .arrow:before{border-right-color:#34668c;border-left-color:#34668c}", ""]);

// exports
